import { render, staticRenderFns } from "./_BroadcastDetailsContent.vue?vue&type=template&id=2cf97016&scoped=true&"
import script from "./_BroadcastDetailsContent.vue?vue&type=script&lang=js&"
export * from "./_BroadcastDetailsContent.vue?vue&type=script&lang=js&"
import style0 from "./_BroadcastDetailsContent.vue?vue&type=style&index=0&id=2cf97016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf97016",
  null
  
)

export default component.exports